import { toNumberOrUndefined } from 'commerce-products-lib/utils/toNumber';
export const getBundleItemPreviewVariables = productBundleItems => ({
  requests: [...productBundleItems.values()].map(bundleItem => ({
    requestId: String(bundleItem.objectId),
    propertyValues: Object.entries(bundleItem.properties).map(([name, {
      value
    }]) => ({
      name,
      value
    }))
  }))
});
export const parseBundleItemPreviewResponse = previewData => previewData.previews.reduce((calculatedChangesMap, preview) => {
  const bundleItemId = toNumberOrUndefined(preview.requestId);
  if (bundleItemId) {
    calculatedChangesMap.set(bundleItemId, preview.calculationProperties.reduce((propertyChanges, property) => {
      if (property.name) {
        propertyChanges[property.name] = property.value;
      }
      return propertyChanges;
    }, {}));
  }
  return calculatedChangesMap;
}, new Map());